// extracted by mini-css-extract-plugin
export default {"main_cont":"Main_main_cont__UrkPW","main":"Main_main__v688+","tit":"Main_tit__qjo7r","fadeIn":"Main_fadeIn__yjO8P"};